import mutations from './mutations'
import * as actions from './actions'

let state = {
    items: [],
    currentId: null,
    tableColumnNames: [],

    comparators: {
        date: ['>=', '<=', '=', 'is empty'],
        autocomplete: ['=', '!='],
        select: ['=', '!='],
        bool: ['is', 'is not'],
        number: ['>=', '<=', '=', '!='],
        string: ['=', '!=', 'contains'],
        search: ['=', '!=', 'contains'],
    },

    filterMappings: {
        projects: [
            {
                name: 'Name',
                field: 'name',
                type: 'string',
            },
            {
                name: 'Company',
                field: 'company_id',
                type: 'autocomplete',
                autocomplete_type: 'company',
            },
            {
                name: 'Project Manager',
                field: 'assigned_to',
                type: 'autocomplete',
                autocomplete_type: 'user',
            },
            {
                name: 'Status',
                field: 'status',
                type: 'select',
                options: [
                    {text: 'Open', value: 21},
                    {text: 'Closed', value: 36},
                ],
            },
            {
                name: 'Building',
                field: 'building',
                type: 'string',
            },
            {
                name: 'Street',
                field: 'street',
                type: 'string',
            },
            {
                name: 'Created At',
                field: 'created_at',
                type: 'date',
            },
            {
                name: 'Updated At',
                field: 'updated_at',
                type: 'date',
            },
        ],

        proposals: [
            {
                name: 'Number',
                field: 'number',
                type: 'string',
            },
            {
                name: 'Contact',
                field: 'contact_id',
                type: 'autocomplete',
                autocomplete_type: 'contact',
            },
            {
                name: 'Company',
                field: 'company_id',
                type: 'autocomplete',
                autocomplete_type: 'company',
            },
            {
                name: 'Address',
                field: 'street',
                type: 'search',
            },
            {
                name: 'Status',
                field: 'status',
                type: 'select',
                options: [
                    {text: 'Awaiting Signature', value: 1},
                    {text: 'Dropped', value: 3},
                    {text: 'Approved', value: 6},
                    {text: 'Declined', value: 7},
                    {text: 'On Hold', value: 12},
                ],
            },
            {
                name: 'Created By',
                field: 'created_by',
                type: 'autocomplete',
                autocomplete_type: 'user',
            },
            {
                name: 'Created At',
                field: 'created_at',
                type: 'date',
            },
            {
                name: 'Updated At',
                field: 'updated_at',
                type: 'date',
            },
        ],

        servicesUpcoming: [
            {
                name: 'Project',
                field: 'project_id',
                type: 'autocomplete',
                autocomplete_type: 'project',
            },
            { 
                field: 'project_address',
                name: 'Address',
                type: 'string',
            },
            {
                field: 'project_name',
                name: 'Project Name',
                type:'search',
            },
            {
                field: 'service_title',
                name: 'Service',
                type: 'autocomplete',
                autocomplete_type: 'service',
            },
            {
                field: 'estimated_bill_date',
                name: 'Estimated Date',
                type: 'date',
            },
            {
                field: 'final_price',
                name: 'Amount',
                type: 'number',
            },
            {
                field: 'status',
                name: 'Status',
                options: [
                    {text: 'Approved', value: 'approved'},
                    {text: 'Billed', value: 'billed'},
                    {text: 'Draft', value: 'draft'},
                    {text: 'Dropped', value: 'dropped'},
                    {text: 'On hold', value: 'on_hold'},
                    {text: 'Paid', value: 'paid'},
                ],
                type: 'select',
            },
            {
                field: 'last_editor_id',
                name: 'Last Editor',
                type: 'autocomplete',
                autocomplete_type: 'user',
            },
            {
                field: 'type',
                name: 'Type',
                options: [
                    { text: 'Custom', value: 'custom' },
                    { text: 'Initial', value: 'initial' },
                    { text: 'Optional', value: 'optional' },
                ],
                type: 'select',
            },
            {
                field: 'assigned_to',
                name: 'Assigned To',
                type: 'autocomplete',
                autocomplete_type: 'user',
            },
            {
                field: 'project_manager',
                name: 'Project Manager',
                type: 'autocomplete',
                autocomplete_type: 'user',
            },
            {
                field: 'description',
                name: 'Notation',
                type: 'string',
            },
            {
                field: 'reimbursable',
                name: 'Reimbursable',
                type: 'bool',
            },
            {
                field: 'created_at',
                name: 'Created At',
                type: 'date',
            },
            {
                field: 'updated_at',
                name: 'Updated At',
                type: 'date',
            },
        ],

        tasks: [
            {
                name: 'Title',
                field: 'title',
                type: 'string',
            },
            {
                name: 'Location',
                field: 'location',
                type: 'select',
                options: [
                    {text: 'BEST Squad', value: 2078},
                    {text: 'Cushman and Wakefield', value: 878},
                    {text: 'Department of Finance', value: 715, },
                    {text: 'Department of Transportation', value: 738},
                    {text: 'FDNY', value: 657},
                    {text: 'NYC Depart. of Buildings-Staten Island', value: 858},
                    {text: 'NYC DOB - Bronx Borough Office', value: 645},
                    {text: 'NYC DOB - Brooklyn Office', value: 644},
                    {text: 'NYC DOB - Manhattan Office', value: 501},
                    {text: 'NYC DOB - Queens Borough Office', value: 517},
                    {text: 'NYC Landmarks Preservation Commission', value: 656},
                    {text: 'RICONDA MAINTENANCE, INC', value: 1872},
                    {text: 'School Construction Authority (SCA)', value: 963},
                ],
            },
            {
                name: 'Status',
                field: 'status',
                type: 'select',
                options: [
                    {text: 'In Progress', value: 2},
                    {text: 'Completed', value: 4},
                ],
            },
            {
                name: 'Is External',
                field: 'is_external',
                type: 'bool',
            },
            {
                name: 'Is Milestone',
                field: 'is_milestone',
                type: 'bool',
            },
            {
                name: 'Is Package Log',
                field: 'is_package_log',
                type: 'bool',
            },
            {
                name: 'Assignee',
                field: 'assignee_id',
                type: 'autocomplete',
                autocomplete_type: 'user',
            },
            {
                name: 'Last Editor',
                field: 'last_editor_id',
                type: 'autocomplete',
                autocomplete_type: 'user',
            },
            {
                name: 'Due Date',
                field: 'due_date',
                type: 'date',
            },
            {
                name: 'Date Requested',
                field: 'date_requested',
                type: 'date',
            },
            {
                name: 'Date Sent',
                field: 'date_sent',
                type: 'date',
            },
            {
                name: 'Date Received',
                field: 'date_received',
                type: 'date',
            },
            {
                name: 'Creator',
                field: 'creator_id',
                type: 'autocomplete',
                autocomplete_type: 'user',
            },
            {
                name: 'Project',
                field: 'project_id',
                type: 'autocomplete',
                autocomplete_type: 'project',
            },
            {
                name: 'Contact',
                field: 'contact_id',
                type: 'autocomplete',
                autocomplete_type: 'contact',
            },
            {
                name: 'Company',
                field: 'company_id',
                type: 'autocomplete',
                autocomplete_type: 'company',
            },
            {
                name: 'Date Created',
                field: 'date_created',
                type: 'date',
            },
            {
                name: 'Date Completed',
                field: 'date_completed',
                type: 'date',
            },
            {
                name: 'Modified By',
                field: 'modified_by',
                type: 'autocomplete',
                autocomplete_type: 'user',
            },
            {
                name: 'Created At',
                field: 'created_at',
                type: 'date',
            },
            {
                name: 'Updated At',
                field: 'updated_at',
                type: 'date',
            },
        ],
    },
};

export default {mutations, actions, state}
